import React, { FC } from 'react';

import InfoDropdown from './infoDropdown/InfoDropdown';
import { PlayoffFormatSection, TieBreakingProcedureSection } from './infoDropdown/infoSections';

import { PlayoffInfoSectionWrapper } from './styles';

const PlayoffInfoSection: FC = () => {
    return (
        <PlayoffInfoSectionWrapper>
            <InfoDropdown dropdownId="playoffFormat">
                <PlayoffFormatSection />
            </InfoDropdown>
            <InfoDropdown dropdownId="tieBreaking">
                <TieBreakingProcedureSection />
            </InfoDropdown>
        </PlayoffInfoSectionWrapper>
    );
};

export default PlayoffInfoSection;
